import moment from "moment";
import { addDays, calcDaysInRange } from "@helpers/utils";

export const getMomentAtStartOfDay = (date) => {
  return moment(date ?? new Date())
    .hour(0)
    .minute(0)
    .second(0)
    .millisecond(0);
};

export const getMomentAtEndOfDay = (date) => {
  return moment(date ?? new Date())
    .hour(0)
    .minute(0)
    .second(0)
    .millisecond(0);
};

export const HOURS_PER_DAY = 24;

export const MINUTES_PER_HOUR = 60;

export const MILLIS_PER_SECOND = 1000;

export const SECONDS_PER_MINUTE = 60;

export const MILLIS_PER_MINUTE = MILLIS_PER_SECOND * SECONDS_PER_MINUTE;

export const MILLIS_PER_HOUR = MILLIS_PER_MINUTE * MINUTES_PER_HOUR;

export const MILLIS_PER_DAY = MILLIS_PER_HOUR * HOURS_PER_DAY;

export const SECONDS_PER_DAY = MILLIS_PER_DAY / MILLIS_PER_SECOND;

const shiftPeriod = ({ dates, isNext }) => {
  if (
    dates[0].getDate() === 1 &&
    dates[1].getMonth() === dates[0].getMonth() &&
    addDays(dates[1], 1).getMonth() !== dates[0]
  ) {
    // This was a whole month range, so ignore day count and shift a whole month
    const shiftedStart = moment(dates[0]).add(isNext ? 1 : -1, "month");
    const shiftedEnd = shiftedStart.clone().endOf("month");
    return [shiftedStart.toDate(), shiftedEnd.toDate()];
  }

  const numDays = calcDaysInRange(dates[0], dates[1]);
  const newEnd = addDays(dates[0], isNext ? numDays * 2 - 1 : -1);
  const newStart = addDays(dates[0], isNext ? numDays : -numDays);
  return [newStart, newEnd];
};

export const previousPeriod = (dates) => shiftPeriod({ dates, isNext: false });
export const nextPeriod = (dates) => shiftPeriod({ dates, isNext: true });
